import React from 'react';
import { ImageIcon, MessageSquareIcon, CodeIcon, PencilIcon, MusicIcon, VideoIcon, SparklesIcon, LightbulbIcon, ChefHatIcon } from 'lucide-react';
export const getIcon = (iconName: string) => {
  const iconMap: {
    [key: string]: React.ReactNode;
  } = {
    image: <ImageIcon className="h-6 w-6 text-white" data-id="element-1574" />,
    'message-square': <MessageSquareIcon className="h-6 w-6 text-white" data-id="element-1575" />,
    code: <CodeIcon className="h-6 w-6 text-white" data-id="element-1576" />,
    pencil: <PencilIcon className="h-6 w-6 text-white" data-id="element-1577" />,
    music: <MusicIcon className="h-6 w-6 text-white" data-id="element-1578" />,
    video: <VideoIcon className="h-6 w-6 text-white" data-id="element-1579" />,
    sparkles: <SparklesIcon className="h-6 w-6 text-white" data-id="element-1580" />,
    lightbulb: <LightbulbIcon className="h-6 w-6 text-white" data-id="element-1581" />,
    'chef-hat': <ChefHatIcon className="h-6 w-6 text-white" data-id="element-1582" />
  };
  return iconMap[iconName] || <ImageIcon className="h-6 w-6 text-white" data-id="element-1583" />;
};